
export default (requestHandler) => {

    return {
        sendToApi
    }

    function sendToApi(store, next, action) {
        if (!action.data) {
            return next(action);
        }
        //send action & store to api handler
        requestHandler(action, store)
        return next(action);
    }
}


// WEBPACK FOOTER //
// ./modules/Common/middleware/apiRequest.js